/* Peptiva theme — global behaviours */
(function () {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Overlay helper ---------- */
  function ensureOverlay() {
    let overlay = $('.overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'overlay';
      document.body.appendChild(overlay);
    }
    return overlay;
  }

  function openPanel(panel) {
    if (!panel) return;
    const overlay = ensureOverlay();
    panel.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    overlay.onclick = () => closeAllPanels();
  }

  function closeAllPanels() {
    $$('.is-open').forEach((el) => el.classList.remove('is-open'));
    document.body.style.overflow = '';
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAllPanels();
  });

  /* ---------- Mobile nav ---------- */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-mobile-nav-toggle]');
    if (toggle) {
      e.preventDefault();
      openPanel($('.mobile-nav'));
    }
    if (e.target.closest('[data-panel-close]')) {
      e.preventDefault();
      closeAllPanels();
    }
    const cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle && window.cartType !== 'page') {
      const drawer = $('.cart-drawer');
      if (drawer) {
        e.preventDefault();
        openPanel(drawer);
      }
    }
  });

  /* ---------- Cart ---------- */
  async function fetchCart() {
    const res = await fetch(`${window.routes.cart_url}.js`);
    return res.json();
  }

  function updateCartCount(count) {
    $$('.cart-count').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  async function refreshCartDrawer() {
    const drawer = $('.cart-drawer');
    if (!drawer) return;
    try {
      const res = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`);
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const fresh = html.querySelector('.cart-drawer');
      if (fresh) {
        drawer.innerHTML = fresh.innerHTML;
      }
    } catch (err) {
      console.error(err);
    }
  }

  async function addToCart(form) {
    const submit = form.querySelector('[type="submit"]');
    const original = submit ? submit.textContent : '';
    if (submit) {
      submit.disabled = true;
      submit.textContent = 'Adding…';
    }
    try {
      const formData = new FormData(form);
      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      const data = await res.json();
      if (data.status) {
        alert(data.description || data.message || window.cartStrings.error);
        return;
      }
      const cart = await fetchCart();
      updateCartCount(cart.item_count);
      if (window.cartType === 'page') {
        window.location.href = window.routes.cart_url;
        return;
      }
      await refreshCartDrawer();
      const drawer = $('.cart-drawer');
      if (drawer) {
        openPanel(drawer);
      } else {
        window.location.href = window.routes.cart_url;
      }
    } catch (err) {
      console.error(err);
      alert(window.cartStrings.error);
    } finally {
      if (submit) {
        submit.disabled = false;
        submit.textContent = original;
      }
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (form) {
      e.preventDefault();
      addToCart(form);
    }
  });

  async function changeLine(line, quantity) {
    const res = await fetch(`${window.routes.cart_change_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    const cart = await res.json();
    updateCartCount(cart.item_count);
    await refreshCartDrawer();
    if (document.body.classList.contains('template-cart')) {
      window.location.reload();
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (btn) {
      const wrap = btn.closest('[data-cart-line]');
      if (!wrap) {
        // product page quantity widget
        const input = btn.parentElement.querySelector('input');
        if (input) {
          let v = parseInt(input.value, 10) || 1;
          v += btn.dataset.qtyChange === 'up' ? 1 : -1;
          input.value = Math.max(1, v);
        }
        return;
      }
      const line = parseInt(wrap.dataset.cartLine, 10);
      const input = wrap.querySelector('input');
      let v = parseInt(input.value, 10) || 1;
      v += btn.dataset.qtyChange === 'up' ? 1 : -1;
      changeLine(line, Math.max(0, v));
    }
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      const wrap = remove.closest('[data-cart-line]');
      changeLine(parseInt(wrap.dataset.cartLine, 10), 0);
    }
  });

  /* ---------- Product variant selection ---------- */
  function initProductForm(root) {
    const form = $('form[data-product-form]', root);
    if (!form) return;
    const data = $('[data-variant-json]', root);
    if (!data) return;
    let variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }
    const selects = $$('[data-option-selector]', root);
    const idInput = form.querySelector('[name="id"]');
    const priceEl = $('[data-product-price]', root);
    const compareEl = $('[data-product-compare]', root);
    const submit = form.querySelector('[type="submit"]');

    function currentVariant() {
      const chosen = selects.map((s) => s.value);
      return variants.find((v) => v.options.every((opt, i) => opt === chosen[i]));
    }

    function update() {
      const v = currentVariant();
      if (!v) {
        if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
    }

    selects.forEach((s) => s.addEventListener('change', update));
    update();
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const fmt = window.shopMoneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
  }
  window.formatMoney = formatMoney;

  /* ---------- Product gallery ---------- */
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) {
      const main = $('[data-gallery-main]');
      if (main) main.src = thumb.dataset.full || thumb.src;
    }
  });

  /* ---------- Sticky header ---------- */
  function initStickyHeader() {
    const header = $('[data-sticky-type]');
    if (!header) return;
    const wrapper = header.parentElement;
    const type = header.getAttribute('data-sticky-type');

    // Move fixed overlays out of the header wrapper so a sticky/transform on
    // the wrapper can never break their fixed positioning.
    ['.mobile-nav', '.cart-drawer'].forEach((sel) => {
      const el = wrapper ? wrapper.querySelector(sel) : null;
      if (el && el.parentElement !== document.body) document.body.appendChild(el);
    });

    if (!wrapper || type === 'none') return;
    wrapper.classList.add('header-sticky', 'header-sticky--' + type);

    let lastY = window.scrollY || 0;
    let ticking = false;

    function update() {
      const y = window.scrollY || 0;
      wrapper.classList.toggle('header-sticky--stuck', y > 8);
      if (type === 'reveal') {
        const h = header.offsetHeight || 0;
        if (y > h && y > lastY + 2) {
          wrapper.classList.add('header-sticky--hidden');
        } else if (y < lastY - 2) {
          wrapper.classList.remove('header-sticky--hidden');
        }
      }
      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  /* ---------- Collection: sort, facets, columns ---------- */
  function initCollection() {
    // Sort + facet checkboxes auto-submit
    document.addEventListener('change', (e) => {
      if (e.target.matches('[data-sort]')) {
        const form = e.target.form || document.getElementById('FacetForm');
        if (form) form.submit();
        return;
      }
      const facetForm = e.target.closest('[data-facets]');
      if (facetForm && e.target.matches('input[type="checkbox"]')) {
        facetForm.submit();
      }
    });

    // Mobile filters toggle
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-facets-toggle]')) {
        const panel = $('.facets-wrap');
        if (panel) panel.classList.toggle('is-open');
      }
    });

    // Column switcher
    const switcher = $('[data-col-switch]');
    const grid = $('[data-product-grid]');
    if (switcher && grid) {
      const saved = localStorage.getItem('shopCols');
      if (saved) {
        grid.style.setProperty('--cols', saved);
        switcher.querySelectorAll('button').forEach((b) => {
          b.setAttribute('aria-pressed', b.dataset.cols === saved ? 'true' : 'false');
        });
      }
      switcher.addEventListener('click', (e) => {
        const btn = e.target.closest('button[data-cols]');
        if (!btn) return;
        const n = btn.dataset.cols;
        grid.style.setProperty('--cols', n);
        localStorage.setItem('shopCols', n);
        switcher.querySelectorAll('button').forEach((b) => {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initProductForm(document);
    initStickyHeader();
    initCollection();
  });
})();
